var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252.819,
    height: 158.172,
    viewBox: "0 0 252.819 158.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_108803",
    "data-name": "Group 108803",
    transform: "translate(-1660 -813.609)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    transform: "translate(1668.933 813.609) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 123.463,
    ry: 28.551,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 122.963,
    ry: 28.051,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    transform: "translate(1668.933 843.299) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 123.463,
    ry: 28.551,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 122.963,
    ry: 28.051,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    transform: "translate(1668.933 876.754) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 123.463,
    ry: 28.551,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.463,
    cy: 28.551,
    rx: 122.963,
    ry: 28.051,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/spring.5358bba07748367b81e15c47fcefddd1.svg";
export { ForwardRef as ReactComponent };